export enum LAYOUT {
  DEFAULT = 'DEFAULT',
  LIMBIC = 'LIMBIC',
}

export interface ILayout {
  layout?: LAYOUT;
  title?: string;
  subtitle?: string;
}

export interface ILayoutBase {
  title: string;
  subtitle?: string;
  // eslint-disable-next-line
  children: JSX.Element;
}
